// Handles the redirect back from Emergent Google Auth: the session_id arrives
// in the URL fragment, gets exchanged for a session cookie by the backend,
// then the user lands on /admin.
import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { API } from '../api';

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get('session_id');
    fetch(`${API}/auth/session`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ session_id: sessionId }),
    })
      .then(async (r) => {
        if (!r.ok) {
          const body = await r.json().catch(() => ({}));
          throw new Error(body.detail || 'Sign-in failed');
        }
        return r.json();
      })
      .then((user) => navigate('/admin', { state: { user }, replace: true }))
      .catch((e) => navigate('/admin', { state: { authError: e.message }, replace: true }));
  }, [location, navigate]);

  return (
    <div className="section" style={{ textAlign: 'center', minHeight: '60vh' }} data-testid="auth-callback">
      <p>Signing you in…</p>
    </div>
  );
}
